import request from '@/utils/request'
export function createSummary(data) {
  return request({
    url: '/health-im/im/chat-summary/create',
    method: 'post',
    data
  })
}
export function pushSummary(data) {
  return request({
    url: '/health-im/im/chat-summary/push',
    method: 'post',
    data
  })
}

export function getSummaryList(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/page',
    method: 'get',
    params
  })
}

export function getCurSummaryList(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/page-with-param',
    method: 'get',
    params
  })
}

export function getCurSummaryListV2(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/page-with-param-pel',
    method: 'get',
    params
  })
}

export function getSummaryInfo(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/get',
    method: 'get',
    params
  })
}

export function getSummaryLog(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/page-log',
    method: 'get',
    params
  })
}

export function editSummary(data) {
  return request({
    url: '/health-im/im/chat-summary/update',
    method: 'post',
    data
  })
}

export function getChatRecord(params) {
  return request({
    url: '/health-im/im/chat-summary/get-chat-record',
    method: 'get',
    params
  })
}

export function updateChatSummaryImage(data) {
  return request({
    url: `/health-im/im/chat-summary/updateChatSummaryImage`,
    method: 'post',
    data
  })
}

// 更新通话小结（通话记录列表）
export function updateCallChatSummary(data) {
  return request({
    url: `/health-im/im/chat-summary/updateCallAiChatSummary`,
    method: 'post',
    data
  })
}

// 通过小结id查询小结详情（通话记录列表）
export function getChatSummaryById(params) {
  return request({
    url: `/health-im/im/chat-summary/getChatSummaryById`,
    method: 'get',
    params
  })
}

// 删除通话小结
export function deletedCallAiChatSummary(data) {
  return request({
    url: `/health-im/im/chat-summary/deletedCallAiChatSummary`,
    method: 'post',
    data
  })
}

// 中西医诊断合并搜索
export function searchDiagnosis(params) {
  return request({
    url: '/health-recommend/diagnosis/search/new',
    method: 'GET',
    params
  })
}
// ai总结重试
export function aiSummaryRetry(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/ai-summary-retry',
    method: 'GET',
    params
  })
}
export function getFillPreview(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/fill-preview',
    method: 'GET',
    params
  })
}
export function manualByCdrIds(data) {
  return request({
    url: `/health-doctor-assistant/tccc/processed-manual-by-cdr-ids`,
    method: 'post',
    data
  })
}
